import { getDecryptedSession } from '@/utils/session'

const originalGetItem = window.localStorage.getItem
window.localStorage.getItem = function (key) {
  const legacyKeys = ['menu', 'id', 'nik', 'nama', 'jabatan', 'email', 'grade']
  if (legacyKeys.includes(key)) {
    const session = getDecryptedSession()
    if (session && session[key] !== undefined) {
      return typeof session[key] === 'object' ? JSON.stringify(session[key]) : String(session[key])
    }
  }
  return originalGetItem.apply(this, arguments)
}
